var U = Object.defineProperty;
var I = (e, s, t) => s in e ? U(e, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[s] = t;
var w = (e, s, t) => (I(e, typeof s != "symbol" ? s + "" : s, t), t);
var h = (e, s, t) => new Promise((n, i) => {
  var c = (l) => {
    try {
      p(t.next(l));
    } catch (d) {
      i(d);
    }
  }, g = (l) => {
    try {
      p(t.throw(l));
    } catch (d) {
      i(d);
    }
  }, p = (l) => l.done ? n(l.value) : Promise.resolve(l.value).then(c, g);
  p((t = t.apply(e, s)).next());
});
const b = () => {
  if (typeof global != "undefined" && typeof global.crypto == "object" && crypto.randomUUID)
    return crypto.randomUUID();
  const e = Date.now().toString(36), s = Math.random().toString(36).substr(2);
  return e + s;
}, A = () => typeof window != "undefined", u = () => {
  if (!A())
    return !1;
  const e = window.navigator.userAgent || window.navigator.vendor, s = "ExpoApp" in window;
  return e && e.indexOf("expo") >= 0 || s;
}, f = (e) => {
  if (typeof e == "string")
    try {
      return JSON.parse(e);
    } catch (s) {
      return;
    }
}, oe = (e, s) => ({
  messageId: b(),
  type: e,
  status: "success",
  payload: s
}), a = (e, s, t) => ({
  messageId: b(),
  type: e,
  payload: s,
  timeout: t
}), o = {
  storageSetData: "storage:set-data",
  storageGetData: "storage:get-data",
  storageRemoveData: "storage:remove-data",
  storageClear: "storage:clear",
  webviewUpdateUrl: "webview:update-url",
  oneSignalSetUserId: "onesignal:set-user-id",
  linkShare: "link:share",
  linkOpen: "link:open",
  browserOpen: "browser:open",
  browserOpenAuthSession: "browser:open-auth-session",
  appleTrackingPermissions: "apple:tracking-permissions",
  statusBarSetColor: "statusBar:set-color",
  analyticsEnable: "analytics:enable",
  analyticsSetUserId: "analytics:set-user-id",
  analyticsLogEvent: "analytics:log-event",
  analyticsSetConsents: "analytics:set-consents",
  analyticsGetConsents: "analytics:get-consents",
  analyticsShowConsentsModal: "analytics:show-consents-modal"
}, m = {
  messageTimeoutMs: 5e3,
  // dedicated for long running tasks eg. showing consents modal to user
  messageTimeoutLongMs: 1e3 * 60 * 60 * 12
  // 12 hours
}, r = (e) => new Promise(
  (s, t) => {
    var p;
    window.ReactNativeWebView || t(
      `[ExpoBridge] ReactNativeWebView is not accessible! ${e.type}`
    );
    const n = (p = e.timeout) != null ? p : m.messageTimeoutMs, i = setTimeout(() => {
      window.removeEventListener("message", c), t(`[ExpoBridge] Timed-out for ${e.type}`);
    }, n), c = (l) => {
      const d = f(l.data);
      !d || d.messageId !== e.messageId || (clearTimeout(i), window.removeEventListener("message", c), d.status === "error" && t(`[ExpoBridge] Error returned for ${e.type}`), d.status === "success" && s(d));
    };
    window.addEventListener("message", c);
    const g = JSON.stringify(e);
    window.ReactNativeWebView.postMessage(g);
  }
).catch((s) => {
  throw console.error(s), s;
}), v = () => h(void 0, null, function* () {
  return r(
    a(o.analyticsGetConsents, null)
  );
}), P = () => r(
  a(
    o.appleTrackingPermissions,
    null,
    m.messageTimeoutLongMs
  )
), M = {
  trackingPermissions: P
}, S = (e) => h(void 0, null, function* () {
  return r(
    a(o.analyticsSetConsents, {
      consents: e
    })
  );
}), x = (e) => h(void 0, null, function* () {
  return r(
    a(o.analyticsEnable, { value: e })
  );
}), E = (e) => h(void 0, null, function* () {
  return r(
    a(
      o.analyticsShowConsentsModal,
      e,
      m.messageTimeoutLongMs
    )
  );
}), D = {
  title: "We use cookies and similar technologies to improve your experience, analyze usage, and show personalized ads. Please manage your consent options below.",
  acceptAll: "Accept All",
  denyAll: "DenyAll",
  save: "Save Preferences",
  consents: {
    analyticsStorage: "Help us improve the app by allowing us to collect and store anonymous usage data such as app performance and feature usage.",
    adStorage: "Allow us to store information about your interaction with ads, including frequency and performance data.",
    adUserData: "Allow us to collect information about you (e.g., age, gender, interests) to show relevant ads.",
    adPersonalization: "Allow us to show you ads personalized based on your behavior and interactions in the app."
  }
}, R = (...s) => h(void 0, [...s], function* (e = D) {
  var i;
  if (!u())
    return;
  if (!(yield v()).payload.consents) {
    const c = yield E({
      defaultValues: {},
      copy: e
    }), {
      analyticsStorage: g = !1,
      adStorage: p = !1,
      adUserData: l = !1,
      adPersonalization: d = !1
    } = (i = c.payload.consents) != null ? i : {};
    yield S({
      analyticsStorage: g,
      adPersonalization: d,
      adStorage: p,
      adUserData: l
    });
  }
  yield M.trackingPermissions(), yield x(!0);
}), k = (e) => h(void 0, null, function* () {
  if (u())
    return r(
      a(o.analyticsLogEvent, e)
    );
}), O = (e) => h(void 0, null, function* () {
  if (u())
    return r(
      a(o.analyticsSetUserId, { value: e })
    );
}), B = {
  title: "We use cookies and similar technologies to improve your experience, analyze usage, and show personalized ads. Please manage your consent options below.",
  acceptAll: "Accept All",
  denyAll: "DenyAll",
  save: "Save Preferences",
  consents: {
    analyticsStorage: "Help us improve the app by allowing us to collect and store anonymous usage data such as app performance and feature usage.",
    adStorage: "Allow us to store information about your interaction with ads, including frequency and performance data.",
    adUserData: "Allow us to collect information about you (e.g., age, gender, interests) to show relevant ads.",
    adPersonalization: "Allow us to show you ads personalized based on your behavior and interactions in the app."
  }
}, z = (...s) => h(void 0, [...s], function* (e = B) {
  var g;
  if (!u())
    return;
  const n = (g = (yield v()).payload.consents) != null ? g : {}, c = (yield E({
    // default values may be handy while you want to edit existing consents
    defaultValues: n,
    copy: e
  })).payload.consents;
  if (c) {
    const {
      analyticsStorage: p = !1,
      adStorage: l = !1,
      adUserData: d = !1,
      adPersonalization: C = !1
    } = c;
    yield S({
      analyticsStorage: p,
      adPersonalization: C,
      adStorage: l,
      adUserData: d
    });
  }
}), ae = {
  getConsents: v,
  setConsents: S,
  logEvent: k,
  setEnabled: x,
  setUserId: O,
  showConsentsModal: E,
  showUpdateConsentsModal: z,
  initAnalytics: R
}, T = (e, s) => {
  if (u())
    return r(
      a(o.browserOpen, { url: e, browserParams: s })
    );
}, N = (e, s, t) => {
  if (u())
    return r(
      a(o.browserOpenAuthSession, {
        url: e,
        redirectUrl: s,
        options: t
      })
    );
}, $ = {
  open: T,
  openAuthSession: N
};
var G = /* @__PURE__ */ ((e) => (e.CANCEL = "cancel", e.DISMISS = "dismiss", e.OPENED = "opened", e.LOCKED = "locked", e))(G || {});
const V = (e) => e.type === o.webviewUpdateUrl, re = (e) => {
  const s = (t) => {
    const n = f(t.data);
    if (!n || !V(n))
      return;
    const { query: i, path: c } = n.payload, g = `${c}${i}`;
    e({ fullpath: g, pathname: c, search: i });
  };
  return window.addEventListener("message", s), () => {
    window.removeEventListener("message", s);
  };
}, W = (e) => {
  if (!u()) {
    window.location.href = e;
    return;
  }
  return r(
    a(o.linkOpen, { value: encodeURI(e) })
  );
}, J = (e, s) => {
  if (u())
    return r(
      a(o.linkShare, { url: e, options: s })
    );
}, j = {
  open: W,
  share: J
}, H = (e, s) => e[s];
class F {
  constructor() {
    w(this, "registeredListeners");
    w(this, "isListenerRunning", !1);
    w(this, "register", (s, t) => {
      var n;
      return Array.isArray(this.registeredListeners[s]) || (this.registeredListeners[s] = []), (n = this.registeredListeners[s]) == null || n.push({ handler: t }), this.runListener(), () => {
        this.unregister(s, t);
      };
    });
    w(this, "unregister", (s, t) => {
      var n, i;
      this.registeredListeners[s] && (this.registeredListeners[s] = (n = this.registeredListeners[s]) == null ? void 0 : n.filter(
        (c) => t !== c.handler
      ), ((i = this.registeredListeners[s]) == null ? void 0 : i.length) === 0 && delete this.registeredListeners[s], this.shouldStopListener() && this.stopListener());
    });
    w(this, "runListener", () => {
      this.isListenerRunning || (this.isListenerRunning = !0, window.addEventListener("message", this.handleMessage));
    });
    w(this, "stopListener", () => {
      window.removeEventListener("message", this.handleMessage), this.isListenerRunning = !1;
    });
    w(this, "shouldStopListener", () => !Object.values(
      this.registeredListeners
    ).every((t) => t && !!t.length));
    w(this, "handleMessage", (s) => {
      const t = f(s.data);
      if (!t)
        return;
      const n = H(
        this.registeredListeners,
        t.type
      );
      n && n.forEach((i) => {
        i.handler(t);
      });
    });
    this.registeredListeners = {};
  }
}
const L = new F(), K = {
  add: L.register,
  remove: L.unregister
}, Q = (e) => {
  if (u())
    return r(a(o.oneSignalSetUserId, { id: e }));
}, X = {
  setUserId: Q
}, Y = (e) => {
  if (u())
    return r(a(o.statusBarSetColor, { value: e }));
}, Z = {
  setStatusBarColor: Y
}, _ = {
  get(e) {
    return r(
      a(o.storageGetData, {
        key: e
      })
    ).then((s) => s.payload.value ? decodeURIComponent(s.payload.value) : void 0).catch(() => {
    });
  },
  set(e, s) {
    return r(
      a(o.storageSetData, {
        key: e,
        value: encodeURIComponent(s)
      })
    ).then(() => !0).catch(() => !1);
  },
  remove(e) {
    return r(
      a(o.storageRemoveData, {
        key: e
      })
    ).then(() => !0).catch(() => !1);
  },
  clear() {
    return r(
      a(o.storageClear, null)
    ).then(() => !0).catch(() => !1);
  }
}, q = {
  get(e) {
    return new Promise((s) => {
      try {
        const t = localStorage.getItem(e);
        s(t != null ? t : void 0);
      } catch (t) {
        s(void 0);
      }
    });
  },
  set(e, s) {
    return new Promise((t) => {
      try {
        localStorage.setItem(e, s), t(!0);
      } catch (n) {
        t(!1);
      }
    });
  },
  remove(e) {
    return new Promise((s) => {
      try {
        localStorage.removeItem(e), s(!0);
      } catch (t) {
        s(!1);
      }
    });
  },
  clear() {
    return new Promise((e) => {
      try {
        localStorage.clear(), e(!0);
      } catch (s) {
        e(!1);
      }
    });
  }
}, ee = () => u() ? _ : q, y = ee(), se = {
  get: y.get,
  set: y.set,
  remove: y.remove,
  clear: y.clear
}, te = {
  storage: se,
  apple: M,
  linking: j,
  browser: $,
  oneSignal: X,
  listener: K,
  statusBar: Z
};
A() && !("ExpoBridge" in window) && (console.log("Registering ExpoBridge in app12"), Object.defineProperty(window, "ExpoBridge", {
  value: te
}));
export {
  y as AppStorage,
  te as ExpoBridge,
  o as MessageTypes,
  G as WebBrowserResultType,
  ae as analyticsModule,
  M as appleModule,
  P as appleTrackingPermissions,
  $ as browserModule,
  oe as createDirectMessageResponse,
  a as createMessageRequest,
  L as eventsListener,
  u as getIsExpoApp,
  j as linkingModule,
  re as listenForUpdateUrlMessage,
  K as listenerModule,
  X as oneSignalModule,
  T as openBrowser,
  N as openBrowserAuthSession,
  W as openLink,
  r as sendMessage,
  Q as setOnesignalUserId,
  Y as setStatusBarColor,
  J as shareLink,
  Z as statusBarModule,
  se as storageModule
};
